import { readMessageUseCase } from '@src/main/modules/messages/application/use-cases/update/read-message.usecase';
import { createInboxMessageHttpRepository } from '@src/main/modules/messages/infrastructure/repository/InboxMessageHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';

export const useReadMessage = () => {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  const tokenProvider = useMemo(
    () => ({
      getToken: () => Promise.resolve(user?.token ?? ''),
    }),
    [user?.token],
  );

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createInboxMessageHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async (id: string) => {
      if (!repository) throw new Error('Repository not initialized');
      return await readMessageUseCase(id, tokenProvider);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['inboxMessages'] });
    },
  });
};
